export default ({ Reservation }, { payload: { reservation } }) => {
    const loadedReservation = Reservation.withId(reservation.id);
    loadedReservation.delete();
};
